import { Controller } from '@hotwired/stimulus'

// Bulk actions controller for glossary terms index
// Usage: data-controller="admin--glossary--bulk-actions"
export default class extends Controller {
  static targets = ['selectAll', 'checkbox', 'bulkForm', 'statusSelect', 'selectedCount']

  connect() {
    this.updateUI()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
    this.updateUI()
  }

  toggleOne() {
    this.updateUI()
  }

  updateUI() {
    const checkedBoxes = this.checkboxTargets.filter((cb) => cb.checked)
    const count = checkedBoxes.length
    const total = this.checkboxTargets.length

    // Update select all state
    this.selectAllTarget.checked = count === total && total > 0
    this.selectAllTarget.indeterminate = count > 0 && count < total

    // Update selected count display
    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = count > 0 ? `${count} selected` : ''
    }

    // Enable/disable bulk form
    if (this.hasBulkFormTarget) {
      const submitBtn = this.bulkFormTarget.querySelector('button[type="submit"]')
      if (submitBtn) {
        submitBtn.disabled = count === 0
        submitBtn.classList.toggle('opacity-50', count === 0)
        submitBtn.classList.toggle('cursor-not-allowed', count === 0)
      }
    }
  }

  submitBulkAction(event) {
    event.preventDefault()

    const checkedBoxes = this.checkboxTargets.filter((cb) => cb.checked)
    if (checkedBoxes.length === 0) {
      return
    }

    const status = this.statusSelectTarget.value
    if (!status) {
      return
    }

    // Build form data
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = this.bulkFormTarget.dataset.url

    // CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)

    // Status
    const statusInput = document.createElement('input')
    statusInput.type = 'hidden'
    statusInput.name = 'status'
    statusInput.value = status
    form.appendChild(statusInput)

    // Term IDs
    checkedBoxes.forEach((cb) => {
      const idInput = document.createElement('input')
      idInput.type = 'hidden'
      idInput.name = 'term_ids[]'
      idInput.value = cb.value
      form.appendChild(idInput)
    })

    document.body.appendChild(form)
    form.submit()
  }
}
